// CSS側のz-index最大値（9999）を超える値
export const Z_INDEX_TOP = 10000;
export default Z_INDEX_TOP;
